import { z } from 'zod';

import { Foreclosure } from '../loan/Foreclosure';
import { StopSettings } from '../loan/StopSettings';
import { BaseLoanEvent } from './BaseLoanEvent';

const BaseForeclosureEvent = Foreclosure.pick({
  referralDate: true,
  lawFirm: true,
  attorneyName: true,
  attorneyPhone: true,
});

export const SetLoanStatusForeclosureEvent = BaseLoanEvent.extend({
  type: z.literal('setLoanStatusForeclosure'),
  ...BaseForeclosureEvent.shape,
  stopSettings: StopSettings.pick({
    portalPayments: true,
    emailsPaused: true,
    documentAccessPaused: true,
  }),
});
export type SetLoanStatusForeclosureEvent = z.infer<typeof SetLoanStatusForeclosureEvent>;
